import currentAcademicInstitution from './academicInstitutions.js.erb';
import { isGdprCountry, isCautiousCountry } from './countries.js.erb';

const isExplicitConsentEnabled = countryCode => isGdprCountry(countryCode)
    || (isCautiousCountry(countryCode) && !currentAcademicInstitution().us);

export default isExplicitConsentEnabled;
